import { MutationObserverOptions, useMutation } from 'react-query';

import { WithdrawXvsInput, WithdrawXvsOutput, withdrawXvs } from 'clients/api';
import queryClient from 'clients/api/queryClient';
import FunctionKey from 'constants/functionKey';

const useWithdrawXvs = (
  options?: MutationObserverOptions<
    WithdrawXvsOutput,
    Error,
    WithdrawXvsInput
  >,
) =>
  useMutation(
    FunctionKey.WITHDRAW_XVS,
    withdrawXvs,
    {
      ...options,
      onSuccess: (...onSuccessParams) => {
        queryClient.invalidateQueries(FunctionKey.GET_XVS_WITHDRAWABLE_AMOUNT);
        queryClient.invalidateQueries(FunctionKey.GET_MINTED_USERINFO);

        if (options?.onSuccess) {
          options.onSuccess(...onSuccessParams);
        }
      },
    },
  );

export default useWithdrawXvs;
